function accounting_auth_check(auth, elm) {
    var $ = jQuery.noConflict();

    if(auth == 'oauth') {
        // 1: Am I logged in now?
        // Yeah?: Reload
        // No?: Go on

        $.get('/accounting/oauth/status', function(answer) {
            if(answer == 0) {
                // 2: Where do I need to go?
                // Expected: url
                if(getCookie('waiting_for_accounting_oauth',0) === 0) {
                    elm.find('.screen-placeholder').attr('data-ori-html', elm.find('.screen-placeholder').html()).html('Bezig met inloggen...');
                    setCookie('waiting_for_accounting_oauth', 1, 0.02);
                    elm.isLoading();
                    $.get('/accounting/oauth/getLoginUrl', function(url) {
                        setTimeout(function() {
                            accounting_auth_check(auth, elm);

                            window.open(url, "Connection", "width=800,height=600");
                        },100);


                    });
                } else {
                    setTimeout(function() {
                        accounting_auth_check(auth, elm);
                    },3000);
                }

                // 3: Redirect to url and wait for return

                // 4: Retry
            } else {
                if(getCookie('waiting_for_accounting_oauth',0) === 1) {
                    setCookie('waiting_for_accounting_oauth', 0, -1);
                    elm.doneLoading();
                    elm.find('.screen-placeholder').html(elm.find('.screen-placeholder').attr('data-ori-html'));
                    elm.find('input#auth').remove();

                    reload_location_if_needed(false);
                }
            }
        });
    }
}